import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        zipcode: '',
        containers_list: null,
        containerdetailes: [],
        type: 'NEW',
        purpose: 'STORAGE',
        delivery: 'DELIVERY',
        cscterms: false,
        CSCSurvey: null,
        currentSurveyObject: null,
        termsCheckbox: false,
        lineItemHaulerPrice: null,
        lineItemMarket: null,
        predelivery: {
            doordirection: null,
            deliveryspace: null,
            rustacknowledge: null,
            deliveryinstructions: "",
            deliveryname: "",
            deliveryphone: "",            
            nonacceptabledates: [],
            deliverysurfacetype: "",
            softSurfaceAcknowledge: false
        },
        prepickup: {
            rustacknowledge: null,
            inspection: null,
            pickupinstructions: "",
            pickupname: ""
        },
        feedbackGiven: false,
        country_code: "US"//By default country will be USA.
    },
    getters,
    mutations,
    actions,
});